module.exports = __webpack_public_path__ + "logout-ce568960d301e05b4bc07510892218fc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/main/logout.svg
// module id = 164
// module chunks = 0 1 2